<template>
  <div>
    <headtop />
    <bannerSwiper :bannerList="bannerList" />
    <titletop
      title="智垒概况"
      enTitle="eneral situation"
    >
      <img
        src="@/image/zm/g.png"
        style="display: block; width: 32px; height: 52px"
        alt
      />
    </titletop>
    <div class="situat-wrap clearfix">
      <div class="fl situat-left">
        <div class="situat-title c_333">我们是谁？</div>
        <div class="situat-text">高速度 高质量 高性价比</div>
        <div
          class="default-line"
          style="margin-top12px;"
        ></div>
        <p>
          深圳市智垒网科技术有限公司专注于智慧出行软件技术研发及推广，利用移动互联网，大数据及云计算等先进技术，帮助传统道路运输企业实现信息化升级，打造企业专属的本地出行服务平台。
        </p>
      </div>
      <div class="fr situat-right">
        <img
          class="situat-img"
          src="@/image/index/icon_about.png"
        />
      </div>
    </div>
    <img
      src="@/image/index/icon_staut.png"
      class="situat-bg-img"
      alt=""
    >

    <titletop
      title="我的产品"
      enTitle="ight major products"
    >
      <img
        src="@/image/zm/e.png"
        style="display: block; width: 32px; height: 52px"
        alt
      />
    </titletop>
    <myproduct />
    <customkc>
      <template v-slot:customkcIndex>
        <div class="custom-kc clearfix">
          <div class="custom-kc-left fl">
            <div>定制快车</div>
            <p class="c_333">
              在班车客运业务的基础上开展定制客运服务<br />
              定制客运在业内称为“定制快车”、“定制快线”、“城际快线”等，本质就<br />是“化三段为一段”，班次灵活安排。用7-9座商务车为乘客提供“门到门”<br />的客运服务，或者在生活区、商业区、高铁、机场、企业、学校等车站外区域<br />设置停靠点，让乘客就近上落车。同时提供线上预订、支付、位置查询等互联<br />网服务。通过这种价格适中、便捷、优质的平台化服务，满足市场需求，增加<br />营收，创造利润。
            </p>
          </div>
          <div class="custom-kc-right fr"></div>
        </div>
      </template>
    </customkc>

    <titletop
      title="成功案例"
      enTitle="successful cases"
    >
      <img
        src="@/image/zm/w.png"
        style="display: block; width: 41px; height: 48px"
        alt
      />
    </titletop>
    <swiperpro />

    <div class="server-wrap">
      <titletop
        title="服务流程"
        enTitle="service process"
      >
        <img
          src="@/image/zm/s.png"
          style="display: block; width: 29px; height: 49px"
          alt
        />
      </titletop>
      <servertr :showAll="false" />
      <div
        @click="goToprocess"
        class="swiper-btn"
      >更多</div>
    </div>

    <titletop
      title="招募与合作"
      enTitle="ecruitment and cooperation"
    >
      <img
        src="@/image/zm/r.png"
        style="display: block; width: 32px; height: 48px"
        alt
      />
    </titletop>
    <cooperat />
    <div style="padding-bottom: 77px">
      <titletop
        title="常见问题"
        enTitle="faq"
      >
        <img
          src="@/image/zm/q.png"
          style="display: block; width: 32px; height: 51px"
          alt
          class="wracs"
        />
      </titletop>
      <uestion :showAll="false" />
      <div
        class="swiper-btn"
        @click="goToCommonproblem"
      >更多</div>
    </div>

    <footb />

    <!-- <el-backtop>
      <div class="upclass"></div>
    </el-backtop> -->

    <!-- <consultant /> -->
  </div>
</template>

<script>
import banner1 from "@/image/banner/icon_banner_index.png";
import headtop from "@/components/headtop/headtop.vue";
import bannerSwiper from "@/components/banner/index.vue";
import titletop from "@/components/titletop/index.vue";
import myproduct from "@/components/myproduct/index.vue";
import customkc from "@/components/customkc/index.vue";
import swiperpro from "@/components/swiperpro/index.vue";
import servertr from "@/components/servertr/index.vue";
import cooperat from "@/components/cooperat/index.vue";
import uestion from "@/components/uestion/index.vue";
import footb from "@/components/footb/index.vue";
import consultant from "@/components/consultant/index.vue";
console.log(0)
import util from "@/util.js";
console.log(4)
util()
export default {
  data () {
    return {
      bannerList: [banner1]
    };
  },
  components: {
    headtop,
    titletop,
    bannerSwiper,
    myproduct,
    customkc,
    swiperpro,
    servertr,
    cooperat,
    uestion,
    footb,
    consultant
  },
  methods: {
    goToCommonproblem () {
      this.$router.push({ name: 'commonproblem' })
    },
    goToprocess () {
      this.$router.push({ name: 'process' })
    },
    install (Vue, mixin, autoModeConfig = false) {
      if (typeof autoModeConfig === 'string') {
        autoModeConfig = {
          ...autoModeConfigDefault,
          selector: '',
        };
      }
      if (autoModeConfig === true) {
        autoModeConfig = autoModeConfigDefault;
      }
      const injector = new Vue({ ...Component, ...mixin });
      injector.$mount();
      Vue.prototype.$ImageViewer = injector;

      if (!autoModeConfig) return;

      // 给body加mutationObserver观测
      const observer = new MutationObserver(mutationsList => {
        // eslint-disable-next-line
        for (const mutation of mutationsList) {
          const nodes = mutation.addedNodes;
          if (nodes.length !== 0) {
            // eslint-disable-next-line
            for (let node of nodes) {
              if (node.dataset.trigger) {
                node.onclick = () => {
                  injector.settings({
                    trigger: node,
                  });
                };
              }
            }
          }
        }
      });
      observer.observe(autoModeConfig.container, {
        childList: true,
        subtree: true,
      });
    },
  }
};

</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue